// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__jZg9J","floatingHidden":"styles_floatingHidden___Ne2N"};